import { useEffect } from 'react';
import { useNavigateWithQuery } from '@nxsys/hooks/useNavigateWithQuery';
import { registerRecordNotFoundHandler } from '@nxsys/services/navigation/recordNotFound';

/**
 * Lets the axios interceptor send a detail screen whose record is refused to
 * the 404 page through the router (keeping the query, e.g. the auth code),
 * replacing the screen in the history so Back does not return to it.
 */
const RecordNotFoundRedirect = () => {
  const navigate = useNavigateWithQuery();

  useEffect(
    () =>
      registerRecordNotFoundHandler((path) =>
        navigate(path, { replace: true }),
      ),
    [navigate],
  );

  return null;
};

export default RecordNotFoundRedirect;
